import { router } from '@/router'
import { Auth } from '@/models/auth'
import { User } from '@/models/user'
import { UserAPI } from '@/api/user.api'
import { BASE_PATH_APP } from '@/commons/config'

import JwtDecode from 'jwt-decode'
import GlobalStore from '@/store/modules/global'

import { map } from 'rxjs/operators'
import { BehaviorSubject, Observable } from 'rxjs'
import { Sector } from '@/models/sector'

const AUTH = `${BASE_PATH_APP}-auth`
const userApi = new UserAPI()

export interface UserJwtDecode {
  sub: number;
  name: string;
  username: string;
  email: string;
  roles: Array<string>;
  sector: Sector;
}

const currentUser = () => {
  const { token = null, functionalities = [] } = JSON.parse(localStorage.getItem(AUTH)) || {}

  if (!token) return null

  const { sub, name, username, email, roles, sector } = JwtDecode<UserJwtDecode>(token)
  return new User(sub, name, username, email, sector, functionalities, roles)
}

const userSubject = new BehaviorSubject(currentUser())

userSubject.subscribe((user: User) => {
  if (GlobalStore) {
    GlobalStore.setUser(user)
  }
})

const login = (usernameOrEmail: string, password: string, returnUrl?: string): Observable<User> => {
  return userApi
    .signin(usernameOrEmail, password)
    .pipe(map(response => setSession(response, returnUrl)))
}

const logout = (): void => {
  localStorage.removeItem(AUTH)
  userSubject.next(null)
  router.push('/login')
}

const logoutSiePedidos = (isEntidade: boolean): void => {
  localStorage.removeItem(AUTH);
  localStorage.removeItem("dadosUserLogado");
  userSubject.next(null);
  if(isEntidade) router.push("/carteira-macrorregiao/entidade/login");
  else router.push('/carteira-macrorregiao/grafica/')
};

const setSession = (authResult: any, returnUrl: any): User => {
  buildAuth(authResult)

  userSubject.next(currentUser())
  router.push(returnUrl || '/')

  return userSubject.value
}

const buildAuth = ({ token, functionalities }: Auth) => {
  localStorage.setItem(AUTH, JSON.stringify({ token, functionalities }))
}

const currentToken = () => {
  const { token = null } = JSON.parse(localStorage.getItem(AUTH)) || {}
  return token
}

export default {
  login,
  logout,
  get currentUserValue () {
    return userSubject.value
  },
  get token () {
    return currentToken()
  },
  logoutSiePedidos
}
